import { useMemo } from 'react';
import { useIsClient } from '@fiverr-private/hooks';

/**
 * README: Handling different client and server content
 * https://beta.reactjs.org/reference/react-dom/hydrate#handling-different-client-and-server-content
 */
export const useHydrationState = (componentId = '') => {
    const isClient = useIsClient();

    const componentKey = useMemo(() => `${componentId}_${String(isClient)}`, [isClient, componentId]);

    return {
        isClient,
        componentKey,
    };
};
